"use client";

import { PackagesSectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";
import GeneratedPackagesSection from "../Components/GeneratedPackagesSection";

const Packages: FC<PackagesSectionProps> = (props) => {
  return <GeneratedPackagesSection {...props} />;
};

export default Packages;
